import React from "react"
import { withRouter } from "react-router-dom"
import { view } from "react-easy-state"

class LtiPage extends React.Component {
  async componentDidMount() {
    const { jwt } = this.props.match.params
    localStorage.setItem("token", '"' + jwt + '"');
    localStorage.setItem("userType", "\"student\"");
    window.location.href = "/";
  }
  render() {
    return (
      <div className="page">
        <h3>Learner is starting... please wait.</h3>
      </div>
    )
  }
}

export default withRouter(view(LtiPage))